import type { UiLanguage } from '@pebblecode/shared';

import { useUiLang } from '../state/prefs.js';
import { en, type Messages } from './en.js';
import { ro } from './ro.js';

export type { Messages } from './en.js';

export const catalogs: Record<UiLanguage, Messages> = { en, ro };

/** The active message catalog. */
export function useT(): Messages {
  return catalogs[useUiLang()];
}

/** "3 min ago" in the UI language. */
export function timeAgo(iso: string | number, lang: UiLanguage, now = Date.now()): string {
  const then = typeof iso === 'number' ? iso : Date.parse(iso);
  const seconds = Math.round((then - now) / 1000);
  if (Math.abs(seconds) < 10) return catalogs[lang].time.justNow;
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto', style: 'short' });
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
    ['second', 1],
  ];
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size || unit === 'second') {
      return rtf.format(Math.round(seconds / size), unit);
    }
  }
  return '';
}
